import { Route, Switch } from 'react-router-dom';
import FormatComponent from './formats/Format.component';
import ImportDataComponent from './importData/ImportData.component';
import Regions from './regions/Region.component';
import Flags from './flags/Flag.component';




const Routes = () => {

    return (
        <Switch>
            <Route exact path="/manutencao-horarios" component={Flags} />
            <Route exact path="/manutencao-horarios/regionais" component={Regions} />
            <Route exact path="/manutencao-horarios/formatos" component={FormatComponent} />
            <Route exact path="/manutencao-horarios/importar" component={ImportDataComponent} />
            <Route component={() => <>NotFoundRedirect</>} />
        </Switch>
    );
}

export default Routes;